<template>
  <div class="share">
    <img :src="accountInfo.shareChangePointbgUrl" class="share_bgc" />
    <img
      src="@/assets/images/account/share_btn.png"
      class="share_btn"
      @click="share"
      v-if="accountInfo.shareChangePointbgUrl"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  methods: {
    share() {
      this.$router.push({
        path: '/share',
        query: {
          qrTicket: `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${this.accountInfo.qrTicket}`,
          personalCode: this.accountInfo.personalCode,
        },
      })
    },
  },
  computed: {
    ...mapState(['accountInfo']),
  },
}
</script>
<style lang="scss" scoped>
.share {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  margin-top: 10px;
  .share_bgc {
    width: 100%;
  }
  .share_btn {
    position: absolute;
    width: 20%;
    bottom: 10%;
  }
}
</style>
